import ProductAPI from 'dashboard/api/products';
import { createStore } from 'dashboard/store/storeFactory';

export const useProductsStore = createStore({
  name: 'products',
  type: 'pinia',
  API: ProductAPI,
});
